import { ReactNode } from "react";

export interface SentinelPageProps {
  help?: ReactNode;
}
export interface SentinelPage {
  href: string;
  label: string;
}
export interface DropDownData {
  id: string;
  name: string;
}

export interface SentinelBasePageProps {
  children: ReactNode;
  header?: string;
  description?: string;
}

export enum SentinelPages {
  OVERVIEW_PAGE = "overviewPage",
  ONBOARD_PAGE = "onboardPage",
  TEAMPROFILE_PAGE = "teamProfilePage",
}
